import { modalActions, appActions } from '../helpers/constants';

const initialState = {
  showModal: false,
  modalType: null,

  defaultAuthenticationForm: 'signIn',

  isSuspended: false
}

const reducer = (state = initialState, action) => {

  const { type, payload } = action;

  switch (type) {
    case modalActions.SHOW_MODAL:
      return {
        ...state,
        showModal: true,
        modalType: payload
      }
    case modalActions.HIDE_MODAL:
      return {
        ...state,
        showModal: false,
        modalType: null
      }
    case modalActions.SET_DEFAULT_AUTHENTICATION_FORM:
      return {
        ...state,
        defaultAuthenticationForm: payload
      }
    case modalActions.SUSPEND_MODAL:
      return {
        ...state,
        isSuspended: payload
      }
    case appActions.USER_LOG_OUT:
      return {
        ...state,
        showModal: false,
        modalType: null,
        defaultAuthenticationForm: 'signIn'
      }
    default:
      return {
        ...state
      }
  }

}

export { reducer as modalReducer };